import { inject, observer } from "mobx-react";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { Form, FormSelectProps, Button,Segment,Checkbox} from "semantic-ui-react";
import { IAppModel } from "../../../AppModel";
export interface ITitleDDL extends FormSelectProps, WithTranslation {
  appStore?: IAppModel;
}

@inject("appStore")
@observer
class TitleDDL extends React.Component<ITitleDDL> {
  public state = {
    titleOther: false
  };
  public options = this.props.appStore!.enumItems("titleType").slice();
  public optionsCheck = this.options.slice().map((op: any) => {
    return op.value;
  });
  //check 'นาย', 'นาง', 'นางสาว' only
  public optionsStandard =this.options.slice(0,3).map((op: any) => {
    return op.value;
  });
  public componentDidMount() {
    if(this.props.value ){
      if (!this.optionsStandard.includes(this.props.value)) {
        this.setState({ titleOther: true });
      }else{
        this.setState({ titleOther: false });
      }
    }
    if (this.props.value && this.options.length) {
      if (!this.optionsCheck.includes(this.props.value)) {
        this.options.slice().push({
          key: this.props.value,
          text: this.props.value,
          value: this.props.value
        });
      }
    }
  }
  public componentDidUpdate(prevProps: any) {
    if (this.props.value !== prevProps.value) {
      if (!this.optionsStandard.includes(this.props.value)) {
        this.setState({ titleOther: true });
      }else{
        this.setState({ titleOther: false });
      }
      if (this.props.value && this.options.length) {
        if (!this.optionsCheck.includes(this.props.value)) {
          this.options.slice().push({
            key: this.props.value,
            text: this.props.value,
            value: this.props.value
          });
          this.optionsCheck = this.options.slice().map((op: any) => {
            return op.value;
          });
          this.forceUpdate();
        }
      }
    }
  }

  public render() {
    const {
      id,
      search,
      value,
      onChange,
      fluid,
      placeholder,
      width,
      label,
      required,
      t,
      onChangeOther
    } = this.props;
    if (!this.options.length) {
      this.options = this.props.appStore!.enumItems("titleType").slice();
    }
    this.optionsCheck = this.options.slice().map((op: any) => {
      return op.value;
    });
    if (this.props.value && !this.optionsCheck.includes(this.props.value)) {
      this.options.push({
        key: this.props.value,
        text: this.props.value,
        value: this.props.value
      });
    }
    return (
      <React.Fragment>
         { this.state.titleOther ? 
        <Checkbox
        onChange={(event: any, data: any) =>
          this.setState({ titleOther: data.checked })
        }
        id={`form-input-titleOther`}
          checked={this.state.titleOther}
        />

        :null}
      { this.state.titleOther ? (
          <Form.Input
                label={t("component.idCardReader.titleOther")}
                width={5}
                placeholder={t("module.loan.components.specifyOtherDetails")}
                onChange={onChangeOther}
                value={value?value==" " ?value.trim() :value :value}
              /> 
          
      ) : 
      <Form.Select
      required={required}
      id={id}
      fluid={fluid}
      search={search}
      options={this.options}
      placeholder={placeholder}
      label={label}
      width={width}
      value={value}
      onChange={onChange}
    />
        }
    </React.Fragment>
    );
  }
}
const styles: any = {
  formInput: {
    marginTop: 14
  },
  formGroup: {
    flexWrap: "wrap",
    flexDirection: "initial"
  }
};
export default withTranslation()(TitleDDL);
